export enum StatusEnum {
  FAILED = 'Failed',
  INIT = 'Initial',
  SUCCESS = 'Success',
}
